__turbopack_context__.v({
  "showAllBlockCustom": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlockCustom",
  "showAllBlockCustom__content": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlockCustom__content",
  "showAllBlockCustom__content_gradient": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlockCustom__content_gradient",
  "showAllBlockCustom__content_short_md": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlockCustom__content_short_md",
  "showAllBlockCustom__content_short_sm": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlockCustom__content_short_sm",
  "showAllBlock__button": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlock__button",
  "showAllBlock__button_grey": "ShowAllBlockCustom-module-scss-module__d0HyBW__showAllBlock__button_grey",
});
